import React from 'react';
import { Section } from './Section';
import { BarChart3 } from 'lucide-react';
export function Proof() {
  return <Section data-id="element-152">
      <div className="max-w-4xl mx-auto bg-brand-blue/10 border border-brand-blue/30 p-8 md:p-12 text-center" data-id="element-153">
        <BarChart3 className="w-16 h-16 text-brand-blue mx-auto mb-6" data-id="element-154" />
        <h2 className="font-display font-bold text-2xl md:text-4xl mb-6 uppercase tracking-tight" data-id="element-155">
          La ciencia detrás de los resultados
        </h2>
        <p className="text-lg md:text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-156">
          En solo 7 días, la mayoría de los hombres reportan una{' '}
          <strong className="text-white" data-id="element-157">
            disminución del 40% en su ansiedad inicial
          </strong>
          .
        </p>
        <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-158">
          Para el día 22, el control ya no es algo en lo que piensas, es algo
          que tu cuerpo ejecuta de manera automática.
        </p>
        <div className="inline-block bg-brand-blue text-white font-bold py-2 px-6 uppercase tracking-widest text-sm" data-id="element-159">
          No es magia, es neurobiología aplicada al rendimiento masculino.
        </div>
      </div>
    </Section>;
}